import { render } from "./MakePage.vue?vue&type=template&id=3449ca60"
import script from "./MakePage.vue?vue&type=script&lang=js"
export * from "./MakePage.vue?vue&type=script&lang=js"
script.render = render

export default script